import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const VerifyEmail = () => {
  const [token, setToken] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Ambil email dari state atau dari URL params
    const params = new URLSearchParams(location.search);
    const urlToken = params.get('token');
    const urlEmail = params.get('email');
    const stateEmail = location.state?.email;

    if (urlEmail) {
      setEmail(urlEmail);
    } else if (stateEmail) {
      setEmail(stateEmail);
    }

    if (urlToken) {
      setToken(urlToken);
      handleVerifyFromURL(urlEmail || stateEmail || '', urlToken);
    }
  }, [location]);

  const handleVerifyFromURL = async (urlEmail, urlToken) => {
    // Jika ada token di URL, coba verifikasi langsung
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/auth/verify-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: urlEmail, token: urlToken }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess('Email berhasil diverifikasi! Silakan login.');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setError(data.error || 'Verifikasi gagal');
      }
    } catch (err) {
      console.log('Verification check:', err.message);
      setError('Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/auth/verify-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, token }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Verifikasi gagal');
        return;
      }

      setSuccess(data.message + ' Silakan login.');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError('Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResendToken = async () => {
    if (!email) {
      setError('Email harus diisi untuk kirim ulang token');
      return;
    }

    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/auth/resend-verification`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Gagal mengirim ulang token');
        return;
      }

      setSuccess(data.message);
    } catch (err) {
      setError('Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md">
        <h1 className="text-3xl font-bold text-center mb-2 text-blue-600">Yayasan BCN</h1>
        <h2 className="text-2xl font-bold mb-6 text-center">Verifikasi Email</h2>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}

        {success && (
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
            {success}
          </div>
        )}

        <form onSubmit={handleVerify} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Masukkan email Anda"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Token Verifikasi</label>
            <input
              type="text"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Masukkan token dari email"
              required
            />
            <p className="text-xs text-gray-500 mt-2">
              Token dikirim ke email Anda. Cek folder spam jika tidak ada di inbox.
            </p>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 disabled:bg-gray-400 font-semibold"
          >
            {loading ? 'Sedang memverifikasi...' : 'Verifikasi Email'}
          </button>
        </form>

        <p className="text-center mt-4 text-sm text-gray-600">
          Atau buka link verifikasi yang dikirim ke email Anda
        </p>

        <div className="mt-4 text-center">
          <button
            type="button"
            onClick={handleResendToken}
            disabled={loading || !email}
            className="text-blue-600 hover:underline text-sm font-semibold disabled:text-gray-400"
          >
            {loading ? 'Mengirim ulang token...' : 'Kirim ulang token verifikasi'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
